import { RouteObject } from "react-router-dom";
import { PAYMENT_CHECKOUT, PAYMENT_CHECKOUT_RETURN } from "constants/urls";

export default [
  {
    index: true,
    path: PAYMENT_CHECKOUT,
    lazy: () => import("modules/payment/pages/PaymentCheckout"),
  },
  {
    path: PAYMENT_CHECKOUT_RETURN,
    lazy: () => import("modules/payment/pages/PaymentCheckoutReturn"),
  },
] as RouteObject[];
